<template>
<div class="content">
  <el-row>
    <el-col :span="6">
      <div class="grid-content"></div>
    </el-col>
    <el-col :span="2" style="border-bottom:1px solid #E1E5E8; line-height:35px">
      <div class="grid-content"><span><strong>登录</strong></span></div>
    </el-col>
  </el-row>

  <el-row>
    <el-col :span="4">
      <div class="grid-content"></div>
    </el-col>

    <el-col :span="16" style="margin-top:10px; background-color:white; padding-left:10%; padding-right:10%; padding-top:15px;">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" label-position="left">

        <el-form-item label="登录名" prop="username">
          <el-input v-model="ruleForm.username" placeholder="学号或身份证" size="mini"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="ruleForm.password" placeholder="初始密码或身份证后6位" size="mini"></el-input>
        </el-form-item>

<!--        <el-form-item   prop="verifyCode">
          <el-input type="text" v-model="ruleForm.verifyCode" placeholder="输入验证码">
            <template slot="append">
              <div class="login-code"  @click="refreshCode">
                <SIdentify :identifyCode="identifyCode"></SIdentify>
              </div>
            </template>
          </el-input>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" size="mini">登录</el-button>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>

      </el-form>
    </el-col>

    <el-col :span="6">
      <div class="grid-content"></div>
    </el-col>
  </el-row>
  <el-footer></el-footer>
  <el-dialog title="提示" :visible.sync="loginSuccess" width="30%" center>
    <span>需要注意的是内容是默认不居中的</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hint = false">取 消</el-button>
      <el-button type="primary" @click="loginSuccess = false" size="mini">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import { pclogin,OK} from '../../api/data.js'
  import { Toast} from 'mint-ui';
  import SIdentify from '../identify' //注意引入路径
export default {
  name: 'ComplaintsAndSuggestionsForm',
  data() {
    //自定义验证器校验手机号码
    var checkPhone = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('手机号格式错误'))
      }
    };
    return {
      loginSuccess: false,
      ruleForm: {
        username: '', //用户名
        password: '', //密码
        verifyCode:''
      },
      rules: {
        username: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }, ],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, ],
        verifyCode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      verifyCodeImg:"",
      identifyCodes: '1234567890abcdefjhijkinpqrsduvwxyz',
      identifyCode: '',
      fullscreenLoading: false
    };
  },
  //页面加载调用获取cookie值
  mounted() {

    // 初始化验证码
    this.identifyCode = ''
   // this.makeCode(this.identifyCodes, 4)
    //是否已经登录
    //this.hasLogin()
  },
  methods: {
    hasLogin(){
      let data = JSON.parse(localStorage.getItem("casUser"));
       if (data) {
         let token = data.data.token
         this.casAuthorization = token
         this.$router.push('/pc')

       }
    },
    // 重置验证码
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    submitForm(formName) {
      const _this = this;
      if(_this.ruleForm.username.trim().length===0){
        Toast('账号不能为空')
        return;
      }
      if(_this.ruleForm.password.trim().length===0){
        Toast('密码不能为空')
        return;
      }
/*      if(_this.ruleForm.verifyCode.trim().length===0){
        Toast('验证码不能为空')
        return;
      }
      if (_this.ruleForm.verifyCode.toLowerCase() !== this.identifyCode.toLowerCase()) {
        this.$message.error('请填写正确验证码')
        //
        return
      }*/

      pclogin( this.ruleForm.username,this.ruleForm.password).then(function(res) {
        console.log(res)
        if (res.data.data.studentName) {
          localStorage.setItem("casUser", JSON.stringify(res.data))
          _this.$router.push("/")
          location.reload()
        } else {
          _this.$message.error('账号不存在或密码错误')

        }
      }).catch(function(res) {
        console.log(res);

      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  components:{
    SIdentify
  }

}
</script>


<style scoped>
.form_border {
  border: 1px solid grey;
  padding: 5px;
  border-radius: 10px;
}

.content {
  /* background: #FBFBFB */
}
</style>



// WEBPACK FOOTER //
// src/components/pc/PCLogin.vue